/* DO NOT MODIFY. This is an autogenerated file. */
/* eslint-disable */
import * as React from "react"
import type { SVGProps } from "react"

export const SvgArrowCircleUpLeftSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "100%"}
    height={props.height || "100%"}
    fill="none"
    viewBox="0 0 24 24"
    data-name="SvgArrowCircleUpLeftSolid"
    {...props}
  >
    {props.children}
    <path
      fill="#000"
      fillRule="evenodd"
      d="M19.778 19.778c4.296-4.296 4.296-11.26 0-15.556s-11.26-4.296-15.556 0-4.296 11.26 0 15.556 11.26 4.296 15.556 0m-4.243-4.243a1 1 0 0 1-1.414 0l-3.95-3.95v3.243a1 1 0 0 1-2 0V9.172a1 1 0 0 1 1-1h5.657a1 1 0 1 1 0 2h-3.242l3.95 3.95a1 1 0 0 1 0 1.413"
      clipRule="evenodd"
    />
  </svg>
)
